<!--客户管理-客户列表 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea CCustAuthAllot">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!--权限选择-->
        <el-tree
          class="allotTree"
          ref="tree"
          :data="treeData.access_list"
          show-checkbox
          node-key="function_id"
          :default-checked-keys="treeData.company_access_list"
          :props="treeData.defaultProps"
          default-expand-all>
        </el-tree>

        <!-- 确认 -->
        <el-button
          class="confirm"
          type="primary"
          @click="getCheckedKeys"
          v-if="treeData.access_list.length !== 0">确 认</el-button>
      </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { 
      updataBreadCrumb,
      showToast,
      showLoading,
      hideLoading,
      deepCopy,
      localUserInfo
    } from "../../../../static/js/utility/utility.js"
  import { clientMApi } from "../../../../static/js/api.js"

  export default {
    name: 'CCustAuthAllot',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        treeData: {
          // 权限列表
          access_list: [],
          // 	用户已选权限
          company_access_list: [],
          defaultProps: {
            children: 'children',
            label: 'function_name'
          }
        }
      }
    },
    created: async function () {
    },
    mounted(){
      this.getClientAuthList()
    },
    methods: {
      // 数据处理
      processData: function (data) {
        for(let i in data.access_list){
          if(data.access_list[i].function_id == '1046'){
            data.access_list.splice(i,1)
          }
          if(data.access_list[i].function_name=='极酷智控'){
            data.access_list.splice(i,1)
          }
        }
        for(let i in data.company_access_list){
          if(data.company_access_list[i].function_id == '1047'||data.company_access_list[i].function_id == '1048'||data.company_access_list[i].function_id == '1049'){
            data.company_access_list.splice(i,1)
          }
        }
        this.treeData.access_list = data.access_list
        this.treeData.company_access_list = data.company_access_list
        // console.log('权限列表', this.treeData.access_list)
      },
      // 获取客户权限列表
      getClientAuthList: async function () {
        let vm = this
        let data = {
          company_id: this.$route.query.company_id
        }

        let res = await clientMApi.getClientAuthList(data)
        if (res.meta.code === 200) {
          // console.log('权限列表', res.data)
          vm.processData(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 新增客户权限，返回客户信息列表
      addClientAuth: async function (accessList) {
        let vm = this
        accessList.push('mini_1')
        accessList.push('mini_4')
        let data = {
          company_id: this.$route.query.company_id,
          accessList: accessList
        }

        let res = await clientMApi.addClientAuth(data)
        if (res.meta.code === 200) {
          showToast('权限分配成功')
          // 返回上一页
          setTimeout(function () {
            vm.$router.go(-1)
          }, 1000)
        } else {
          showToast(res.meta.message)
        }
      },
      // 确认新增
      getCheckedKeys() {
        // console.log(this.$refs.tree.getCheckedKeys());
        let accessList = this.$refs.tree.getCheckedKeys()
        this.addClientAuth(accessList)
      }
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CCustAuthAllot{
  /* page- 权限分配  树状选择器 */
  .allotTree>.el-tree-node {
      margin-bottom: 20px;
  }
  .allotTree .el-tree-node__children>.el-tree-node {
      float: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CCustomer/CCustAuthAllot.vue